import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgStar = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={13}
      height={12}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.146 5.059 9.528 7.612l.62 3.605c.008.051.008.094.008.145 0 .187-.087.36-.296.36a.587.587 0 0 1-.288-.086L6.333 9.934l-3.237 1.702a.61.61 0 0 1-.289.086c-.209 0-.303-.173-.303-.36 0-.05.007-.094.015-.145l.62-3.605L.514 5.059c-.086-.094-.18-.217-.18-.346 0-.216.223-.303.404-.332l3.62-.526L5.98.573c.064-.137.187-.296.352-.296.167 0 .289.16.354.296L8.31 3.855l3.62.526c.173.029.403.116.403.332 0 .13-.093.252-.187.346Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgStar;
